export type FeatureAreaMatcher =
  | string
  | ((segments: Array<string | undefined>) => string);

export type FeatureAreaRoutePatterns = Record<string, FeatureAreaMatcher>;

export const createFeatureAreaResolver =
  (routePatterns: FeatureAreaRoutePatterns) =>
  (pathname: string): string => {
    const segments = pathname.replace(/\/+$/, '').split('/').filter(Boolean);
    if (segments.length === 0) {
      return '-';
    }

    const path = segments.join('/');
    for (const [pattern, matcher] of Object.entries(routePatterns)) {
      if (path.startsWith(pattern)) {
        return typeof matcher === 'function' ? matcher(segments) : matcher;
      }
    }

    return '-';
  };
